(() => {
  const selector = '.swinger-image[data-preview]:not(.swinger-image--missing)';
  const imageIntersectionRatiosMap = new Map();
  let imageEqualIntersectionValuesElems = [];

  const videoElement = document.createElement('video');
  videoElement.className = 'swinger-image__preview';
  videoElement.loop = false;
  const videoAttributes = [
    'playsinline',
    'autoplay',
    'muted',
  ];

  const activatePreview = (elem) => {
    if (window.matchMedia('(prefers-reduced-motion)').matches) {
      return;
    }

    if (!window.swinger.user.isLoggedIn()) {
      return;
    }

    if (elem.contains(videoElement)) {
      return;
    }

    const imageElem = window.swinger.$('img', elem)[0];
    const data = elem.getAttribute('data-preview');
    const videos = JSON.parse(data);
    let testImage = new Image();

    const handler = () => {
      const index = videos.findIndex((video) => testImage.currentSrc.indexOf(video.width) > -1);
      const video = videos[index];

      videoElement.src = video.src;
      videoAttributes.forEach((attr) => {
        videoElement[attr] = true;
        videoElement.setAttribute(attr, '');
      });

      if (imageElem && imageElem.parentElement) {
        imageElem.parentElement.appendChild(videoElement);
      }

      testImage.removeEventListener('load', handler);
      testImage = undefined;
    };

    testImage.addEventListener('load', handler);
    testImage.sizes = imageElem && imageElem.sizes ? imageElem.sizes : '100vw';
    testImage.srcset = videos.map((video) => `data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20width='${video.width}'%20height='${video.height}'%3E%3C/svg%3E ${video.width}w`).join(', ');
  };

  videoElement.addEventListener('ended', () => {
    if (imageEqualIntersectionValuesElems.length <= 1) {
      const currentSrc = videoElement.src;

      videoElement.removeAttribute('src');
      window.setTimeout(() => {
        videoElement.src = currentSrc;
        videoAttributes.forEach((attr) => {
          videoElement[attr] = true;
          videoElement.setAttribute(attr, '');
        });
      });
    } else {
      const activeElemIndex = imageEqualIntersectionValuesElems
        .findIndex((entry) => entry.contains(videoElement));
      const nextElemIndex = activeElemIndex === imageEqualIntersectionValuesElems.length - 1
        ? 0
        : activeElemIndex + 1;
      activatePreview(imageEqualIntersectionValuesElems[nextElemIndex]);
    }
  });

  const imageObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const image = entry.target;
      const { intersectionRatio } = entry;

      imageIntersectionRatiosMap.set(image, intersectionRatio);
    });

    if (window.matchMedia('(hover: hover)').matches) {
      return;
    }

    let highestIntersectionRatio = -1;
    let elem;

    imageIntersectionRatiosMap.forEach((value, key) => {
      if (key.matches('.swinger-video-player')) {
        value += 0.1;
      }

      switch (true) {
        default:
        case !key.matches(`${selector},.swinger-video-player`):
          break;

        case (value > highestIntersectionRatio):
          highestIntersectionRatio = value;
          elem = key;
          imageEqualIntersectionValuesElems = [key];
          break;

        case (value === highestIntersectionRatio):
          imageEqualIntersectionValuesElems.push(key);
          break;
      }
    });

    switch (true) {
      default:
        activatePreview(elem);
        break;

      case !elem:
      case elem.matches('.swinger-video-player'):
        videoElement.remove();
        break;
    }
  }, {
    rootMargin: '-10% 0% 0% 0%',
    threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
  });

  window.swinger.observer.initialize('.swinger-image,.swinger-video-player', (elem) => {
    imageObserver.observe(elem);
  }, false);

  window.swinger.eventHub.register('mouseleave focusout', `${selector}, .swinger-card`, () => {
    videoElement.remove();
  });

  window.swinger.eventHub.register('mouseenter focusin', `${selector}, .swinger-card`, (e) => {
    let elem = window.swinger.eventHub.getTarget(e);

    if (!elem.matches(`${selector}`)) {
      elem = elem.querySelector(`${selector}`);
    }

    if (!elem) {
      return;
    }

    activatePreview(elem);
  });
})();
